export default function parseBoolean(
  value: boolean | string | undefined
): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  return value === 'true';
}
